// Local copy of shared tier configs — avoids monorepo linking issues
export type Tier = 'free' | 'pro' | 'super'

export interface TierConfig {
  name:         string
  price:        number
  monthlyLimit: number
  features:     string[]
}

export const TIER_CONFIGS: Record<Tier, TierConfig> = {
  free: {
    name: 'Free', price: 0, monthlyLimit: 0,
    features: [
      'Money Machine growth visualizer',
      'Day-by-day 5-year animation',
      '6 stocks to compare',
      'Race mode — SPY vs NVDA vs AAPL',
    ]
  },
  pro: {
    name: 'Pro', price: 9.99, monthlyLimit: 999,
    features: [
      'Everything in Free',
      'Unlimited chart analyses',
      'All 14 ICT modules',
      'Pro AI chart analysis',
      'Options chain data',
      'Analysis history',
    ]
  },
  super: {
    name: 'Super', price: 99.99, monthlyLimit: 999,
    features: [
      'Everything in Pro',
      'Super AI analysis',
      'Order book + options flow',
      'IV skew + gamma walls',
      'Max pain analysis',
      'Combined chart + options analysis',
      'Live market data (Alpha Vantage)',
      'Priority support',
    ]
  }
}
